
import React from 'react'
import { Modal, Button } from 'antd';

class ViewWorks extends React.Component {

    state = {
        visible: false
    }

    showModal = () => {
        this.setState({ visible: true })

    };

    handleCancel = (e) => {
        this.setState({ visible: false })
    };

    render() {
        return (
            <div id="works" className='block worksBlock'>
                <div className="container-fluid">
                    <div className="titleHolder">
                        <h2>如何使用</h2>
                        <span>僅供輔助使用，數據需依實際狀況判斷處置</span>
                    </div>
                    <div className="contentHolder">
                        <Button type="primary" onClick={this.showModal}>
                            <i className="fas fa-play"></i>
                        </Button>
                    </div>

                    <Modal
                        title="TVBS"
                        visible={this.state.visible}
                        onCancel={this.handleCancel}
                        footer={null}
                    >
                        <iframe title="YouTube" width="100%" height="315" src="https://www.youtube.com/embed/A4FbB8UhNRs" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                    </Modal>
                </div>
            </div>
        )
    }
}

export default ViewWorks